import React, { Component } from 'react';

class IconDownloadBlue extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="19"
                fill="none"
                viewBox="0 0 16 19"
            >
                <path
                    fill="#1D53A5"
                    fillRule="evenodd"
                    d="M15.515 6.658h-4.281V.311H4.807v6.347H.525l7.495 7.406 7.495-7.406zM.525 16.182v2.117h14.99v-2.117H.525z"
                    clipRule="evenodd"
                ></path>
            </svg>
        );
    }
}

export default IconDownloadBlue;